import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Label } from "../ui/label";

/**
 * Shared name+description form used by Category and Brand modals.
 * Consumer calls `<NameDescriptionForm value onChange />` inside the
 * FormModal wrapper — submit is owned by the modal.
 */
export function NameDescriptionForm({ value, onChange, nameFieldLabelKey, descriptionFieldLabelKey, testIdPrefix }) {
  const { t } = useTranslation();
  return (
    <div className="space-y-3">
      <div className="space-y-1.5">
        <Label htmlFor={`${testIdPrefix}-name`}>{t(nameFieldLabelKey)}</Label>
        <Input
          id={`${testIdPrefix}-name`}
          value={value.name || ""}
          onChange={(e) => onChange({ ...value, name: e.target.value })}
          required
          minLength={2}
          maxLength={60}
          data-testid={`${testIdPrefix}-name`}
          className="bg-surface border-border-subtle"
          autoFocus
        />
      </div>
      <div className="space-y-1.5">
        <Label htmlFor={`${testIdPrefix}-description`}>{t(descriptionFieldLabelKey)}</Label>
        <Textarea
          id={`${testIdPrefix}-description`}
          value={value.description || ""}
          onChange={(e) => onChange({ ...value, description: e.target.value })}
          maxLength={300}
          rows={3}
          data-testid={`${testIdPrefix}-description`}
          className="bg-surface border-border-subtle"
        />
      </div>
    </div>
  );
}
